import React from 'react';
import styles from './SummaryWrapper.module.scss';

export default function SummaryWrapper({ children }) {
  return <div className={styles.wrapper}>{children}</div>;
}
